<template>
  <div>
    <div id="alert-message">
      <v-alert
        :color="color"
        :value="showHide"
        :closable="dismissible"
        :type="type"
        :close-icon="CONSTANTS.ICONS_MDI.ICON_CLOSE"
        :height="height"
        @update:model-value="onCloseclicked"
      >
        <div v-if="message !== ''">{{ message }}</div>
      </v-alert>
    </div>
  </div>
</template>

<script lang="ts" setup>
  import CONSTANTS from '@/constants/Config.constants'
  import { AlertTypes } from '@/models/alert-data.model'
  import { assertUnreachable } from '@/utils/helpers'
  import { computed, onMounted, ref } from 'vue'

  interface Props {
    message: string
    type: AlertTypes
    dismissible?: boolean
    ignoreDelay?: boolean
    icon?: string
  }

  const props = withDefaults(defineProps<Props>(), {
    dismissible: false,
    ignoreDelay: false,
    icon: '',
  })

  const showHide = ref(true)
  const height = ref('auto')

  const color = computed(() => {
    switch (props.type) {
      case 'success':
        return 'green'
      case 'info':
        return 'blue lighten-1'
      case 'warning':
      case 'error':
        return 'red accent-4'
      default:
        return assertUnreachable(props.type)
    }
  })

  const emit = defineEmits<{
    (event: 'onCloseclicked', value: void): void
  }>()

  onMounted(() => {
    window.scrollTo(0, 0)
    if (props.type === 'success') {
      setTimeout(() => {
        onCloseclicked()
      }, CONSTANTS.DEFAULT_SUCCESS_TIMEOUT)
      if (showHide.value === true) {
        if (!props.ignoreDelay) {
          setTimeout(() => {
            showHide.value = false
          }, CONSTANTS.DEFAULT_SUCCESS_TIMEOUT)
        }
      }
    }
  })

  function onCloseclicked(): void {
    emit('onCloseclicked')
  }
</script>
<style lang="scss" scoped>
  .vue-alert-link {
    cursor: pointer;
    text-decoration: underline;
    color: white;
  }
</style>
